import { render, staticRenderFns } from "./CreateSuhu.vue?vue&type=template&id=d80c1cd0&scoped=true"
import script from "./CreateSuhu.vue?vue&type=script&lang=js"
export * from "./CreateSuhu.vue?vue&type=script&lang=js"
import style0 from "./CreateSuhu.vue?vue&type=style&index=0&id=d80c1cd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d80c1cd0",
  null
  
)

export default component.exports